<template>
  <Dialog
    v-model:visible="skipModal"
    :draggable="false"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '35vw', minWidth: '360px' }"
    :modal="true"
    :showHeader="false"
    contentStyle="background-color: #F2F8FF"
    class="dialog"
  >
    <section class="grid grid-cols-12 mt-8 gap-5 items-start">
      <div class="col-span-12 md:col-span-4 flex justify-center">
        <img
          :src="require('@/assets/images/avatares/repproved.gif')"
          class="md:w-full w-1/2 rounded-full"
          alt="repproved img"
          loading="lazy"
        />
      </div>
      <div class="col-span-12 md:col-span-8 flex flex-col gap-5">
        <div
          class="w-[100%] flex flex-row justify-center items-center space-x-6"
        >
          <h6 class="w-[80%]">{{ $t("skipModal.title") }}</h6>
          <div>
            <MessageVoice
              :msg="$t('skipModal.subtitle')"
              @onEndMessage="permissToListen"
              :showIconsName="false"
              :scaleIcons="0.8"
            />
          </div>
        </div>
        <p class="text-base w-100">
          {{ $t("skipModal.subtitle") }}
        </p>
      </div>
    </section>
    <section class="flex justify-end gap-2 mt-8">
      <Button class="btn-outline p-button-sm" @click="skipVideo(false)">
        <p>{{ $t("skipModal.finalize") }}</p>
      </Button>
      <Button class="btn-primary p-button-sm" @click="skipVideo(true)">
        <p>{{ $t("skipModal.next") }}</p>
      </Button>
    </section>
    <section class="w-full flex justify-center items-center mt-8 space-x-4">
      <v-icon name="md-spatialaudiooff" class="text-primary-400" />
      <p>
        {{
          $t("labels.generic", {
            pt: "Você também pode responder por voz. Ex: 'Avançar' ou 'Cancelar'",
            en: "You can also reply by voice. Ex: 'Next' or 'Cancel'",
          })
        }}
      </p>
    </section>
  </Dialog>
  <RecordStream
    v-show="recording"
    ref="recordStream"
    encodeType="move_object"
  />
</template>

<script lang="ts">
import { ChatBotService } from "@/components/ChatBot/chat-bot.service";
import { SpeechActions } from "@/components/SpeechRecognition/actions";
import { FeedbackRest } from "@/services/rest/feedback.rest";
import { Subscription } from "rxjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "skipVideo",
  emits: ["onSkipVideo"],
  data() {
    return {
      homeroAvatar: require("@/assets/images/avatares/avatar.svg"),
      loader: false,
      recording: false as boolean,
      talking: true as boolean,
    };
  },
  props: {
    skipModal: [Boolean],
  },
  computed: {
    rest(): FeedbackRest {
      return new FeedbackRest();
    },
    chatbot(): ChatBotService {
      return new ChatBotService();
    },
  },
  created() {
    this.wsSubscription();
  },
  mounted() {
    if (this.skipModal) {
      SpeechActions.skipHasOpen(true);
    }
  },
  methods: {
    skipVideo(value: boolean): void {
      SpeechActions.skipHasOpen(false);
      this.$emit("onSkipVideo", value);
    },
    permissToListen(): void {
      this.recording = true;
      this.talking = false;
      (this.$refs.recordStream as any)?.sendActionWithRecord();
    },
    wsSubscription(): Subscription {
      return this.chatbot.wsMessagesActions().subscribe((e) => {
        const parse = JSON.parse(e);
        if (parse?.hasAction && parse?.action?.type == "next_object") {
          this.skipVideo(parse?.action?.liked);
        }
      });
    },
  },
});
</script>
<style lang="scss" src="./style.scss"></style>
